// Build-time configuration baked in by CRA from REACT_APP_* env vars.
// Default preserves existing behaviour (meet.logx.work) for forgetful redeploys.

export const JITSI_BASE_URL =
  (process.env.REACT_APP_JITSI_BASE_URL || 'https://meet.logx.work').replace(/\/+$/, '');

export const CONFIG_OPTIONS = [
  { key: 'startWithAudioMuted', label: 'Вход с выключенным микрофоном', defaultOn: true },
  { key: 'startWithVideoMuted', label: 'Вход с выключенной камерой', defaultOn: true },
  { key: 'defaultLanguage', label: 'Русский язык', value: 'ru', defaultOn: true, isValueFixed: true },
  { key: 'requireDisplayName', label: 'Требовать имя пользователя при входе', defaultOn: true },
];

export const ROOM_NAME_MAX = 50; // characters of raw input (pre-translit)
export const COPY_TOAST_MS = 2000;
